import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
const IdcardDetails = ({ token }) => {
  const location = useLocation();
  const [tableData, setTableData] = useState([]);
  const [tat, setTat] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://localhost:5199';

const [submitResponse, setSubmitResponse] = useState(null);
   const [dataFromURL, setDataFromURL] = useState({
    firstName: '',
    lastName: '',
    middleName: '',
    dob: '',
    memberId: '',
    gender: '',
    state:'',
    respMessage:''
  }); 
  const [breadcrumb, setBreadcrumb] = useState({
    externalUserIdName: '',
    externalUserIdNamePre: '',
    externalUserIdNew: '',
    userTypeNameNew: '',
    dueDateFromNew: '',
    dueDateToNew: ''
  });

  // Helper to get query params
  const getQueryParam = (param) => {
    const params = new URLSearchParams(location.search);
    return params.get(param);
  };
const fetchData = async () => {
  setLoading(true);
  setError(null);

  try {
    const userId = getQueryParam('userId');
    const status = getQueryParam('status');
    const caseManagerOrQueueId = getQueryParam('externalUserId');
    const dueDateFrom = getQueryParam('startDate');
    const dueDateTo = getQueryParam('endDate');
    const userType = getQueryParam('userType');
    const firstName ="";
    const lastName = "";
    const middleName = "";
    const dob = "";
    const memberId = getQueryParam('memberIds').split("-")[1];
    const gender = "";
    const stateCode = getQueryParam('memberIds').split("-")[0];
    const respMessage ="";

    if (!memberId || !stateCode) {
      setError('Missing required query parameters in URL');
      setLoading(false);
      return;
    }

    setDataFromURL({
      firstName,
      lastName,
      middleName,
      dob,
      memberId,
      gender,
      respMessage
    });

    const params = new URLSearchParams({
      MemberID: memberId,
      StateCode: stateCode
    }).toString();

    const response = await fetch(
      `${API_BASE_URL}/api/IDCard/getidcardplanaction?${params}`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    if (!response.ok) {
      throw new Error('Failed to fetch ID card plan action data');
    }
    const data = await response.json();
const memberDetails = data?.taskStatusList?.memberDetails;
const resMsg =  data?.taskStatusList?.message;

if (memberDetails) {
  setDataFromURL(prev => ({
    ...prev,
    firstName: memberDetails.firstname || '',
    lastName: memberDetails.lastname || '',
    middleName: memberDetails.middleinitial || '',
    dob: memberDetails.dob || '',
    gender: memberDetails.gender || '',
    stateCode:memberDetails.state || '',
    respMessage:resMsg ||''
  }));
}

if(data.taskStatusList.response===null)
  { 
   setError("No active member ID Card Requests");
  setLoading(false);
  return;
}
    if (data && Array.isArray(data.taskStatusList.response.getPlanactionsList)) {
      setTableData(data.taskStatusList.response.getPlanactionsList);
    } else if (Array.isArray(data)) {
      setTableData(data);
    } else {
      setTableData([]);
    }

    setBreadcrumb({
      externalUserIdName: data.externalUserIdName || '',
      externalUserIdNamePre: data.externalUserIdNamePre || '',
      externalUserIdNew: data.externalUserIdNew || '',
      userTypeNameNew: data.userTypeNameNew || '',
      dueDateFromNew: data.dueDateFromNew || '',
      dueDateToNew: data.dueDateToNew || ''
    });
  } catch (err) {
    setError(err.message);
    setTableData([]);
    setTat(null);
  } finally {
    
    setLoading(false);
  }
};
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [location.search, token]);
  
const saveIdCardRequest = async (row,_stateCode, requestType) => {

  setSubmitLoading(true);
  setError(null);
  setSubmitResponse(null);

  try {
    const requestBody = {
      stateCode: _stateCode,
  memberId: getQueryParam('memberIds').split("-")[1],
  recordid: requestType === 'ReIssue' ? '' : row.recordId, // ✅ For cancel, we need to send reasonId as recordid
      IDCardRequestType: requestType, 
      userName: getQueryParam('externalUserId')
    };

    const response = await fetch(
      `${API_BASE_URL}/api/IDCard/requestidcard`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(requestBody)
      }
    );

    if (!response.ok) {
      throw new Error('Failed to save ID Card request');
    }

    const responseData = await response.json();
    const responseMsg = responseData?.response?.message || '';

    if (responseMsg.toUpperCase().includes('ALREADY EXISTS')) {
      setSubmitResponse('Your ID Card Request in progress');
    }
    else  if (responseMsg.toUpperCase().includes('NO ACTIVE COVERAGES')) {
      setSubmitResponse('No active coverages found with provided subscriberId/carrierMemId in order to add/update ID Cards');
    }

    // ✅ refresh grid after success
    await fetchData();

  } catch (err) {
    setError(err.message);
  } finally {
    setSubmitLoading(false);
  }
};
  return (
     <div className="container mt-4">
      {/* ================= Global Progress Bar ================= */}
{(loading || submitLoading) && (
  <div
    className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
    style={{
      backgroundColor: "rgba(255,255,255,0.7)",
      zIndex: 1050
    }}
  >
    <div className="w-50">
      <div className="text-center mb-2 fw-semibold text-primary">
        Processing request, please wait...
      </div>
      <div className="progress">
        <div
          className="progress-bar progress-bar-striped progress-bar-animated"
          style={{ width: "100%" }}
        />
      </div>
    </div>
  </div>
)}


  {/* ================= Member Details ================= */}
  <div className="card shadow-sm mb-4 border-0">
    <div className="card-header text-black-50">
   <div className="card-header">
     <h4 className="mb-0">Member IDCard Request</h4>
 </div>
    </div>

    <div className="card-body">
      <div className="row g-3 mb-4">

        <div className="col-md-4">
          <div className="text-muted small">First Name</div>
          <div className="fw-semibold"> {dataFromURL.firstName || "N/A"}</div> 
        </div>

        <div className="col-md-4">
          <div className="text-muted small">Last Name</div>
          <div className="fw-semibold">{dataFromURL.lastName || "N/A"}</div>
        </div>

        <div className="col-md-4">
          <div className="text-muted small">Middle Name</div>
          <div className="fw-semibold">{dataFromURL.middleName || "N/A"}</div>
        </div>

        <div className="col-md-4">
          <div className="text-muted small">Date of Birth</div>
          <div className="fw-semibold">
            {dataFromURL.dob
              ? new Date(dataFromURL.dob).toLocaleDateString()
              : "N/A"}
          </div>
        </div>

        <div className="col-md-4">
          <div className="text-muted small">Member ID</div>
          <div className="fw-semibold">
            {dataFromURL.memberId || "N/A"}
          </div>
        </div>

        <div className="col-md-4">
          <div className="text-muted small">StateCode</div>
          <div className="fw-semibold">{dataFromURL.stateCode || "N/A"}</div>
        </div>

      </div>

      {/* ================= Buttons ================= */}
      <div className="d-flex justify-content-end gap-2">
       

      
<button
  type="button"
  className="btn btn-primary px-4"
  disabled={submitLoading || (tableData.length >  0 && !dataFromURL.respMessage.includes("Helix") )}
  onClick={() => saveIdCardRequest(tableData[0],dataFromURL.stateCode, 'ReIssue')}
>
  Request New ID Card
</button>


      </div>

    </div>
  </div>

  {/* ================= Messages ================= */}
  {submitResponse && <div className="alert alert-info">{submitResponse}</div>}
  {error && <div className="alert alert-danger">{error}</div>}

  {tat && (
    <div className="alert alert-info">
      <strong>TAT:</strong> {JSON.stringify(tat)}
    </div>
  )}

  {!loading && !error && tableData.length === 0 && (
    <div className="alert alert-warning text-center">
      No data available for this user and status.
    </div>
  )}

  {/* ================= Table ================= */}
  {!loading && !error && tableData.length > 0 && (
    <div className="card shadow-sm border-0">
      <div className="card-header bg-light">
        <h6 className="mb-0">IDCard Request Details</h6>
      </div>

      <div className="table-responsive">
        <table className="table table-bordered table-striped">
          <thead className="table-light">
            <tr>
              <th>Action ID</th>
              <th>Action Type</th>
              <th>Primary ID</th>
              <th>Reason ID</th>
              <th>Second ID</th>
              <th>Source</th>
              <th>Request Date</th>
              <th>Record Id</th>
              {!dataFromURL.respMessage.includes("Helix") && <th>Action</th>}
            </tr>
          </thead>

          <tbody>
            {tableData.map((row, idx) => (
              <tr key={idx}>
                <td>
                  {row.actionID}
                </td>
                <td>{row.actionType}</td>
                <td>{row.primaryId}</td>
                <td>
                  {row.reasonId}
                </td>
                <td>
                  
                  {row.secondId}
                </td>
                <td>{row.source}</td>
                <td>{new Date(row.createDate).toLocaleDateString()  }</td>
                <td>{row.recordId}</td> 
                {!dataFromURL.respMessage.includes("Helix") && (
                  <td>
                    <button
                      type="button"
                      className="btn btn-sm btn-danger"
                      disabled={submitLoading}
                      onClick={() => saveIdCardRequest(row, dataFromURL.stateCode, 'Cancel')}
                    >
                      Cancel Request
                    </button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )}

</div>
  );
};

export default IdcardDetails;
